import { transactionMgmnt, parPage } from "../../config";
import {getQueryStringFrmObject, getApi, postApi, postFormApi} from "../helpers/utility";
class TransManagementApi {

  transCreate = async (transPojo) => {
    // console.log("transMgmntPojo", transPojo);
    if (transPojo) {
      var result = await postApi(transactionMgmnt.transAdd, (transPojo));
      // console.log('result', result)
      return result;
    }
  };
  updateBoardlist = async (transPojo) => {
    // console.log("transpojo", transPojo);
    if (transPojo) {
      // console.log("trans pojo", JSON.stringify(transPojo));
      var result = await postApi(transactionMgmnt.transUpdate, (transPojo));
      return result;
    }
  };
  bulkUpdatelist = async (transPojo) => {
    // console.log("transpojo", transPojo);
    if (transPojo) {
      // console.log("trans pojo", JSON.stringify(transPojo));
      var result = await postApi(transactionMgmnt.transBulk_Update, (transPojo));
      return result;
    }
  };
  readBoardlist= async (readFilter, page) => {
    let finalListEndPoint;
    // console.log('readFilter',readFilter);
    finalListEndPoint = transactionMgmnt.translist  + "?per_page=" + parPage+"&pageNo="+page;
    let searchParams = { info: readFilter };
     if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    // console.log('result', result)
    return result;
  };
  readDashboardlist= async (readFilter, page) => {
    let finalListEndPoint;
    // console.log('readFilter',readFilter);
    finalListEndPoint = transactionMgmnt.transDashboardlist  + "?per_page=" + parPage+"&pageNo="+page;
    let searchParams = { info: readFilter };
     if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    // console.log('result', result)
    return result;
  };
  findById = async (masterId) => {
    var result = await getApi(transactionMgmnt.findById, masterId);
    return result;
  };
  transListShow= async (readFilter, sharePageNo, bondPageNo) => {
    let finalListEndPoint;
    // console.log('readFilter',readFilter);
    finalListEndPoint = transactionMgmnt.translistShow  + "?per_page=" + parPage + "&sharePageNo=" + sharePageNo + "&bondPageNo=" + bondPageNo;
    let searchParams = { info: readFilter };
     if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    // console.log('result', result)
    return result;
  };
  readPaymentlist= async (readFilter, page) => {
    let finalListEndPoint;
    // console.log('readFilter',readFilter);
    finalListEndPoint = transactionMgmnt.paymentList  + "?per_page=" + parPage+"&pageNo="+page;
    let searchParams = { info: readFilter };
     if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    // console.log('result', result)
    return result;
  };
  readUnMatchPaymentlist= async (readFilter,match, p_page,t_page) => {
    // console.log('match', match, p_page,t_page)
    let finalListEndPoint;
    // console.log('readFilter',readFilter);
    finalListEndPoint = transactionMgmnt.unMatchPayment  + "?p_per_page=" + parPage+"&p_pageNo="+p_page+"&t_per_page=" + parPage+"&t_pageNo="+t_page+"&match="+match;
    let searchParams = { info: readFilter };
     if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      // console.log('queryString', queryString)
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    // console.log('result', result)
    return result;
  }
  matchPayment = async (transPojo) => {
    // console.log("transpojo", transPojo);
    if (transPojo) {
      // console.log("trans pojo", JSON.stringify(transPojo));
      var result = await postApi(transactionMgmnt.matchPayment, (transPojo));
      return result;
    }
  };
  
}
export default new TransManagementApi();
